<div
    class="labelled-block-textbox"
    (click)="focusWrapTarget()"
    [ngClass]="{ selected: isFocused }"
>
    <div *ngIf="icon; else searchInput" class="icon-container">
        <mat-icon svgIcon="{{ icon }}" class="search-icon"></mat-icon>
        <div style="width: 100%">
            <ng-container *ngTemplateOutlet="searchInput"> </ng-container>
        </div>
    </div>
</div>

<ng-template #searchInput>
    <div data-cy="search-bar-title" class="header">
        {{ header }}
    </div>
    <div data-cy="search-bar">
        <ng-content data-cy="search-bar"></ng-content>
    </div>
</ng-template>
